import { Button } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const ReloadScreenButton: FC = () => {
  const { t } = useTranslation();

  const onReload = () => {
    window.location.reload();
  };

  return (
    <Button type="link" onClick={onReload}>
      {t('reload')}
    </Button>
  );
};
